var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 203,
    viewBox: "0 0 200 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00028 171.897C10.6163 190.482 23.0343 194.351 31.7651 190.482C48.6502 183.001 92.5118 174.642 137.559 194.29C197.222 220.313 209.916 181.051 190.875 141.337C171.834 101.622 165.38 61.4599 187.331 39.3328C209.282 17.2056 180.557 -17.4092 129.544 18.6224C96.5774 41.9074 72.3839 36.7225 59.392 30.14C47.1476 23.9361 33.5304 17.4504 20.7723 22.5144C5.2918 28.6595 -0.807998 41.9821 22.7449 71.7452C56.1213 113.922 -14.072 130.24 3.00028 171.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.0103 81.3643H152.538V172.52C152.538 172.705 152.465 172.883 152.333 173.014C152.202 173.146 152.024 173.22 151.838 173.22H34.7103C34.5246 173.22 34.3465 173.146 34.2153 173.014C34.084 172.883 34.0103 172.705 34.0103 172.52V81.3643Z",
    fill: "#C5C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M122.804 45.6426H67.6905L34.0103 81.364H152.538L122.804 45.6426Z",
    fill: "#787A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.2368 31.3535L67.6902 45.6422L34.01 81.3636L8.49463 61.9719L45.2368 31.3535Z",
    fill: "#C5C6CA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M145.257 31.3535L122.803 45.6422L152.538 81.3636L181.999 61.9719L145.257 31.3535Z",
    fill: "#C5C6CA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.1698 32.0844C82.8034 31.784 83.2964 31.2503 83.5457 30.5949C83.7951 29.9395 83.7814 29.2131 83.5077 28.5675L73.4068 4.74955C73.2637 4.41218 73.0539 4.10722 72.79 3.85302C72.526 3.59882 72.2134 3.40061 71.8709 3.27033C71.5284 3.14005 71.1631 3.08038 70.7969 3.09491C70.4307 3.10944 70.0713 3.19786 69.7402 3.35487L67.7942 4.27761C67.4631 4.43461 67.1671 4.65694 66.9242 4.93124C66.6812 5.20554 66.4962 5.52614 66.3803 5.87377C66.2644 6.2214 66.2199 6.58888 66.2497 6.95411C66.2794 7.31935 66.3827 7.6748 66.5534 7.99909L78.6001 30.8941C78.9267 31.5147 79.4804 31.9851 80.1457 32.2069C80.8109 32.4287 81.5362 32.3848 82.1698 32.0844Z",
    fill: "#787A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M94.8336 29.7755C95.2922 29.7429 95.7204 29.5343 96.0288 29.1933C96.3372 28.8524 96.5019 28.4054 96.4885 27.9459L95.9896 10.9896C95.9825 10.7494 95.9269 10.5132 95.8262 10.295C95.7255 10.0769 95.5817 9.88131 95.4035 9.72014C95.2252 9.55898 95.0163 9.43551 94.7891 9.35717C94.562 9.27882 94.3213 9.24722 94.0816 9.26425L92.6728 9.36463C92.4332 9.38169 92.1996 9.44701 91.9859 9.55666C91.7721 9.66632 91.5828 9.81805 91.4292 10.0027C91.2756 10.1874 91.161 10.4012 91.0921 10.6314C91.0233 10.8615 91.0016 11.1032 91.0286 11.3419L92.9363 28.1979C92.9879 28.6548 93.2141 29.0742 93.5677 29.3682C93.9213 29.6622 94.3749 29.8082 94.8336 29.7755Z",
    fill: "#787A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M104.61 36.0437C105.871 36.7729 107.642 36.1037 108.624 34.5264L126.063 6.51897C127.105 4.84583 126.858 2.80659 125.52 2.03309L123.656 0.955089C122.318 0.18145 120.427 0.984767 119.497 2.72231L103.922 31.8076C103.045 33.4457 103.349 35.3143 104.61 36.0437Z",
    fill: "#787A83"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.e9d1a869e5790a50874662e7df5da6b7.svg";
export { ForwardRef as ReactComponent };